import { SettingConst } from '../../types';

/**
 * Experiment setting for new retailer self-serve nodes taxonomy changes
 */
export const SELF_SERVE_RETAILER_TAXONOMY_240626 =
  'SELF_SERVE_RETAILER_TAXONOMY_240626' as SettingConst<
    'SELF_SERVE_RETAILER_TAXONOMY_240626',
    boolean,
    'HELP_CENTER'
  >;
